import { cardStyles as styles } from "@iewcasia/Overrides/Widgets/InvoiceDetails/InvoiceDetailsLineCard";
import { css } from "styled-components";

styles.partStyles = {
    ...styles.partStyles,
    wrapper: {
        ...styles.partStyles?.wrapper,
        css: css`
            ${styles.partStyles?.wrapper?.css}
            align-items: center;
            flex-direction: row;
        `,
    },
    heading: {
        ...styles.partStyles?.heading,
        variant: "p",
        forwardAs: "span",
        weight: 700,
        css: css`
            ${styles.partStyles?.heading?.css}
            margin-bottom: 0;
            margin-right: 5px;
        `,
    },
    text: {
        ...styles.partStyles?.text,
        variant: "p",
        forwardAs: "span",
        css: css`
            ${styles.partStyles?.text?.css}
            width: auto;
            margin-bottom: 0;
        `,
    },
};
